import React, { useEffect, useState } from "react";
import FormContainer from "../components/form/FormContainer";
import { PageHeader } from "../components/header/PageHeader";
import { useApiClient } from "../shared/customHooks";
import { referenceDataManagementForm } from "../shared/formObjects/referenceDataManagementForm";
import { TabPanel, TabView } from "primereact/tabview";
import Table from "../components/table/Table";
import { referenceDataManagementTable } from "../shared/tableObjects/referenceDataManagementTable";
import { useSearchParams } from "react-router";
import { eventEmitter } from "../shared/event";

export default function ReferenceDataManagement() {
  const defaultTab = "/referenceDataManagement?tab=0";
  const [activeIndex, setActiveIndex] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();

  const api = useApiClient("ReferenceDataManagement");
  const headerText = [
    {
      class: "flex align-center mt-0",
      value: "Reference Data Management",
      icon: "view-app-icon mr-3 mt-0",
    },
  ];

  useEffect(() => {
    const tabParam = Number(searchParams.get("tab"));
    if (!isNaN(tabParam)) {
      setActiveIndex(tabParam);
    }
  }, [searchParams]);

  const handleTabChange = (e: any) => {
    setSearchParams({ tab: e.index });
    eventEmitter.emit("IsDirtyForm", false);
  };

  return (
    <>
      <PageHeader headerText={headerText} icon={"icon"} />
      <div className="referenceData">
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => {
            handleTabChange(e);
          }}>
          <TabPanel header="Reference Data" leftIcon="pi pi-file mr-2">
            <Table apiClient={api} label="Reference Data" columns={referenceDataManagementTable} />
          </TabPanel>
          <TabPanel header="Upload Data" leftIcon="pi pi-upload mr-2">
            <FormContainer
              apiClient={api}
              formBody={referenceDataManagementForm}
              showInternalNotes={false}
              submitRoute={defaultTab}
              cancelPath={defaultTab}
            />
          </TabPanel>
        </TabView>
      </div>
    </>
  );
}
